import { createContext } from "react";

const RegionalesContext = createContext();

export default RegionalesContext;
